import { minutesToMilliseconds } from './datetime.util';

export enum WorkingHoursDailyDistributionRangeBoundaries {
  LOWER = minutesToMilliseconds(0),
  MIDDLE = minutesToMilliseconds(7 * 60),
  UPPER = minutesToMilliseconds(9 * 60),
}

export enum WorkingHoursWeeklyDistributionRangeBoundaries {
  LOWER = minutesToMilliseconds(0),
  MIDDLE = minutesToMilliseconds(30 * 60),
  UPPER = minutesToMilliseconds(50 * 60),
}
